import React from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';

import { theme } from '../../theme/theme';
import { BaseComponent } from '../Component';

export interface SocialButtonComponent extends BaseComponent {
  type: 'socialButton';
  props: SocialButtonProps;
}

export interface SocialButtonProps {
  src: string;
  name: string;
  icon: any;
  color?: string;
}

//read react-share documentation here: https://www.npmjs.com/package/react-share https://www.npmjs.com/package/next-share
export const SocialButton: React.FC<SocialButtonProps> = ({
  src,
  name,
  icon,
  color = theme.palette.secondary.main,
}) => {
  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '0.5rem',
      }}
    >
      <Tooltip title={name}>
        <IconButton
          href={src}
          target="_blank"
          sx={{
            color: 'white',
            backgroundColor: color,
            '&:hover': { backgroundColor: color },
          }}
        >
          {icon}
        </IconButton>
      </Tooltip>

      <Typography variant="body2" color={theme.palette.secondary.main}>
        {name}
      </Typography>
    </Box>
  );
};
